import Validator from 'validatorjs'
import formatErrors from './formatErrors'

const rules = {
  type: 'required|string',
  context: 'required|string'
}

export default function validateHorseReport (values) {
  const validator = new Validator(values, rules, {
    required: 'این فیلد الزامی است',
    string: 'متن معتبر نمی‌باشد'
  })
  validator.passes()
  return formatErrors(validator.errors.all())
}



// WEBPACK FOOTER //
// ./src/utils/validateHorseReport.js